module.exports = __webpack_public_path__ + "img/politicaAmbiental.cdb5613e.png";